/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdapterDownloadUrlResponse } from '../models/adapter-download-url-response';
import { AggregatorsSummaryCollectionResponse } from '../models/aggregators-summary-collection-response';
import { aggregatorsSummaryGet } from '../fn/stores/aggregators-summary-get';
import { AggregatorsSummaryGet$Params } from '../fn/stores/aggregators-summary-get';
import { bulkStoreAmenitiesGetAll } from '../fn/stores/bulk-store-amenities-get-all';
import { BulkStoreAmenitiesGetAll$Params } from '../fn/stores/bulk-store-amenities-get-all';
import { bulkStoreAmenitiesGetDetails } from '../fn/stores/bulk-store-amenities-get-details';
import { BulkStoreAmenitiesGetDetails$Params } from '../fn/stores/bulk-store-amenities-get-details';
import { bulkStoresAmenities } from '../fn/stores/bulk-stores-amenities';
import { BulkStoresAmenities$Params } from '../fn/stores/bulk-stores-amenities';
import { BulkStoresAmenitiesDetailsResponse } from '../models/bulk-stores-amenities-details-response';
import { BulkStoresAmenitiesListResponse } from '../models/bulk-stores-amenities-list-response';
import { BulkStoresAmenitiesResponse } from '../models/bulk-stores-amenities-response';
import { createStore } from '../fn/stores/create-store';
import { CreateStore$Params } from '../fn/stores/create-store';
import { dataGroupsDataGroupIdStoresGet } from '../fn/stores/data-groups-data-group-id-stores-get';
import { DataGroupsDataGroupIdStoresGet$Params } from '../fn/stores/data-groups-data-group-id-stores-get';
import { Empty } from '../models/empty';
import { exportStores } from '../fn/stores/export-stores';
import { ExportStores$Params } from '../fn/stores/export-stores';
import { getStoreAmenities } from '../fn/stores/get-store-amenities';
import { GetStoreAmenities$Params } from '../fn/stores/get-store-amenities';
import { getStoreOrderingDeactivations } from '../fn/stores/get-store-ordering-deactivations';
import { GetStoreOrderingDeactivations$Params } from '../fn/stores/get-store-ordering-deactivations';
import { PaginatedStoresNearbyResponse } from '../models/paginated-stores-nearby-response';
import { PriceOverrides } from '../models/price-overrides';
import { PutResponse } from '../models/put-response';
import { putStoreAmenities } from '../fn/stores/put-store-amenities';
import { PutStoreAmenities$Params } from '../fn/stores/put-store-amenities';
import { searchStores } from '../fn/stores/search-stores';
import { SearchStores$Params } from '../fn/stores/search-stores';
import { Store } from '../models/store';
import { StoreAmenityCollectionResponse } from '../models/store-amenity-collection-response';
import { storeImagesGet } from '../fn/stores/store-images-get';
import { StoreImagesGet$Params } from '../fn/stores/store-images-get';
import { storeImagesPut } from '../fn/stores/store-images-put';
import { StoreImagesPut$Params } from '../fn/stores/store-images-put';
import { StoreImagesResponse } from '../models/store-images-response';
import { StoreOrderingDeactivationsResponse } from '../models/store-ordering-deactivations-response';
import { Stores } from '../models/stores';
import { StoreSearchResponse } from '../models/store-search-response';
import { storesNearby } from '../fn/stores/stores-nearby';
import { StoresNearby$Params } from '../fn/stores/stores-nearby';
import { storesStoreIdAdapterDownloadUrlGet } from '../fn/stores/stores-store-id-adapter-download-url-get';
import { StoresStoreIdAdapterDownloadUrlGet$Params } from '../fn/stores/stores-store-id-adapter-download-url-get';
import { storesStoreIdAggregatorsPut } from '../fn/stores/stores-store-id-aggregators-put';
import { StoresStoreIdAggregatorsPut$Params } from '../fn/stores/stores-store-id-aggregators-put';
import { storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete } from '../fn/stores/stores-store-id-catalog-entry-overrides-catalog-entry-id-channel-id-delete';
import { StoresStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Params } from '../fn/stores/stores-store-id-catalog-entry-overrides-catalog-entry-id-channel-id-delete';
import { storesStoreIdCatalogEntryOverridesCatalogEntryIdGet } from '../fn/stores/stores-store-id-catalog-entry-overrides-catalog-entry-id-get';
import { StoresStoreIdCatalogEntryOverridesCatalogEntryIdGet$Params } from '../fn/stores/stores-store-id-catalog-entry-overrides-catalog-entry-id-get';
import { storesStoreIdGet } from '../fn/stores/stores-store-id-get';
import { StoresStoreIdGet$Params } from '../fn/stores/stores-store-id-get';
import { storesStoreIdPosConfigPut } from '../fn/stores/stores-store-id-pos-config-put';
import { StoresStoreIdPosConfigPut$Params } from '../fn/stores/stores-store-id-pos-config-put';
import { storesStoreIdPut } from '../fn/stores/stores-store-id-put';
import { StoresStoreIdPut$Params } from '../fn/stores/stores-store-id-put';
import { tenantsTenantIdStoresGet } from '../fn/stores/tenants-tenant-id-stores-get';
import { TenantsTenantIdStoresGet$Params } from '../fn/stores/tenants-tenant-id-stores-get';
import { UpdateStoreAmenitiesResponse } from '../models/update-store-amenities-response';
import { updateStoreOrderingStatus } from '../fn/stores/update-store-ordering-status';
import { UpdateStoreOrderingStatus$Params } from '../fn/stores/update-store-ordering-status';
import { UpsertStoreImagesResponse } from '../models/upsert-store-images-response';

@Injectable({ providedIn: 'root' })
export class StoresService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchStores()` */
  static readonly SearchStoresPath = '/stores';

  /**
   * Gets the stores.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStores()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchStores$Response(params: SearchStores$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreSearchResponse>> {
    return searchStores(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the stores.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStores$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchStores(params: SearchStores$Params, context?: HttpContext): Observable<StoreSearchResponse> {
    return this.searchStores$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreSearchResponse>): StoreSearchResponse => r.body)
    );
  }

  /** Path part for operation `createStore()` */
  static readonly CreateStorePath = '/stores';

  /**
   * Create a specified store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStore()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStore$Response(params: CreateStore$Params, context?: HttpContext): Observable<StrictHttpResponse<Store>> {
    return createStore(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a specified store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStore$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStore(params: CreateStore$Params, context?: HttpContext): Observable<Store> {
    return this.createStore$Response(params, context).pipe(
      map((r: StrictHttpResponse<Store>): Store => r.body)
    );
  }

  /** Path part for operation `storesStoreIdGet()` */
  static readonly StoresStoreIdGetPath = '/stores/{storeId}';

  /**
   * Gets a specified store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdGet$Response(params: StoresStoreIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Store>> {
    return storesStoreIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a specified store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdGet(params: StoresStoreIdGet$Params, context?: HttpContext): Observable<Store> {
    return this.storesStoreIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Store>): Store => r.body)
    );
  }

  /** Path part for operation `storesStoreIdPut()` */
  static readonly StoresStoreIdPutPath = '/stores/{storeId}';

  /**
   * Updates a specified Store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdPut$Response(params: StoresStoreIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
    return storesStoreIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a specified Store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdPut(params: StoresStoreIdPut$Params, context?: HttpContext): Observable<PutResponse> {
    return this.storesStoreIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<PutResponse>): PutResponse => r.body)
    );
  }

  /** Path part for operation `storesStoreIdPosConfigPut()` */
  static readonly StoresStoreIdPosConfigPutPath = '/stores/{storeId}/pos-config';

  /**
   * copy parent store POS config to child store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdPosConfigPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdPosConfigPut$Response(params: StoresStoreIdPosConfigPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
    return storesStoreIdPosConfigPut(this.http, this.rootUrl, params, context);
  }

  /**
   * copy parent store POS config to child store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdPosConfigPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdPosConfigPut(params: StoresStoreIdPosConfigPut$Params, context?: HttpContext): Observable<PutResponse> {
    return this.storesStoreIdPosConfigPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<PutResponse>): PutResponse => r.body)
    );
  }

  /** Path part for operation `storesStoreIdAggregatorsPut()` */
  static readonly StoresStoreIdAggregatorsPutPath = '/stores/{storeId}/aggregators';

  /**
   * Updates a specified store's aggregators.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdAggregatorsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdAggregatorsPut$Response(params: StoresStoreIdAggregatorsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
    return storesStoreIdAggregatorsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a specified store's aggregators.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdAggregatorsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdAggregatorsPut(params: StoresStoreIdAggregatorsPut$Params, context?: HttpContext): Observable<PutResponse> {
    return this.storesStoreIdAggregatorsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<PutResponse>): PutResponse => r.body)
    );
  }

  /** Path part for operation `aggregatorsSummaryGet()` */
  static readonly AggregatorsSummaryGetPath = '/stores/{storeId}/aggregators-summary';

  /**
   * Fetch Aggregators summary for a specified store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsSummaryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsSummaryGet$Response(params: AggregatorsSummaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregatorsSummaryCollectionResponse>> {
    return aggregatorsSummaryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch Aggregators summary for a specified store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsSummaryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsSummaryGet(params: AggregatorsSummaryGet$Params, context?: HttpContext): Observable<AggregatorsSummaryCollectionResponse> {
    return this.aggregatorsSummaryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AggregatorsSummaryCollectionResponse>): AggregatorsSummaryCollectionResponse => r.body)
    );
  }

  /** Path part for operation `storesStoreIdAdapterDownloadUrlGet()` */
  static readonly StoresStoreIdAdapterDownloadUrlGetPath = '/stores/{storeId}/adapter-download-url';

  /**
   * Gets a specified store's adapterDownloadUrl.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdAdapterDownloadUrlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdAdapterDownloadUrlGet$Response(params: StoresStoreIdAdapterDownloadUrlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AdapterDownloadUrlResponse>> {
    return storesStoreIdAdapterDownloadUrlGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a specified store's adapterDownloadUrl.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdAdapterDownloadUrlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdAdapterDownloadUrlGet(params: StoresStoreIdAdapterDownloadUrlGet$Params, context?: HttpContext): Observable<AdapterDownloadUrlResponse> {
    return this.storesStoreIdAdapterDownloadUrlGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdapterDownloadUrlResponse>): AdapterDownloadUrlResponse => r.body)
    );
  }

  /** Path part for operation `storesStoreIdCatalogEntryOverridesCatalogEntryIdGet()` */
  static readonly StoresStoreIdCatalogEntryOverridesCatalogEntryIdGetPath = '/stores/{storeId}/catalog-entry-overrides/{catalogEntryId}';

  /**
   * Gets price overrides for catalogEntryId on storeId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdCatalogEntryOverridesCatalogEntryIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdCatalogEntryOverridesCatalogEntryIdGet$Response(params: StoresStoreIdCatalogEntryOverridesCatalogEntryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PriceOverrides>> {
    return storesStoreIdCatalogEntryOverridesCatalogEntryIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets price overrides for catalogEntryId on storeId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdCatalogEntryOverridesCatalogEntryIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdCatalogEntryOverridesCatalogEntryIdGet(params: StoresStoreIdCatalogEntryOverridesCatalogEntryIdGet$Params, context?: HttpContext): Observable<PriceOverrides> {
    return this.storesStoreIdCatalogEntryOverridesCatalogEntryIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PriceOverrides>): PriceOverrides => r.body)
    );
  }

  /** Path part for operation `storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete()` */
  static readonly StoresStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDeletePath = '/stores/{storeId}/catalog-entry-overrides/{catalogEntryId}/{channelId}';

  /**
   * Deletes price overrides for catalogEntryId on storeId for channel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Response(params: StoresStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes price overrides for catalogEntryId on storeId for channel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete(params: StoresStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Params, context?: HttpContext): Observable<Empty> {
    return this.storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

  /** Path part for operation `exportStores()` */
  static readonly ExportStoresPath = '/stores/export';

  /**
   * Export stores data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStores()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStores$Response(params: ExportStores$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return exportStores(this.http, this.rootUrl, params, context);
  }

  /**
   * Export stores data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStores$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStores(params: ExportStores$Params, context?: HttpContext): Observable<string> {
    return this.exportStores$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdStoresGet()` */
  static readonly TenantsTenantIdStoresGetPath = '/tenants/{tenantId}/stores';

  /**
   * Gets all stores by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdStoresGet()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  tenantsTenantIdStoresGet$Response(params: TenantsTenantIdStoresGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Stores>> {
    return tenantsTenantIdStoresGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all stores by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdStoresGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  tenantsTenantIdStoresGet(params: TenantsTenantIdStoresGet$Params, context?: HttpContext): Observable<Stores> {
    return this.tenantsTenantIdStoresGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Stores>): Stores => r.body)
    );
  }

  /** Path part for operation `dataGroupsDataGroupIdStoresGet()` */
  static readonly DataGroupsDataGroupIdStoresGetPath = '/data-groups/{dataGroupId}/stores';

  /**
   * Gets all stores by Data Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataGroupsDataGroupIdStoresGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataGroupsDataGroupIdStoresGet$Response(params: DataGroupsDataGroupIdStoresGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Stores>> {
    return dataGroupsDataGroupIdStoresGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all stores by Data Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataGroupsDataGroupIdStoresGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataGroupsDataGroupIdStoresGet(params: DataGroupsDataGroupIdStoresGet$Params, context?: HttpContext): Observable<Stores> {
    return this.dataGroupsDataGroupIdStoresGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Stores>): Stores => r.body)
    );
  }

  /** Path part for operation `storeImagesGet()` */
  static readonly StoreImagesGetPath = '/stores/{storeId}/images';

  /**
   * Gets store Images.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeImagesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeImagesGet$Response(params: StoreImagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreImagesResponse>> {
    return storeImagesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets store Images.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeImagesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeImagesGet(params: StoreImagesGet$Params, context?: HttpContext): Observable<StoreImagesResponse> {
    return this.storeImagesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreImagesResponse>): StoreImagesResponse => r.body)
    );
  }

  /** Path part for operation `storeImagesPut()` */
  static readonly StoreImagesPutPath = '/stores/{storeId}/images';

  /**
   * Put store Images.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeImagesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeImagesPut$Response(params: StoreImagesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpsertStoreImagesResponse>> {
    return storeImagesPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Put store Images.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeImagesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeImagesPut(params: StoreImagesPut$Params, context?: HttpContext): Observable<UpsertStoreImagesResponse> {
    return this.storeImagesPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpsertStoreImagesResponse>): UpsertStoreImagesResponse => r.body)
    );
  }

  /** Path part for operation `getStoreOrderingDeactivations()` */
  static readonly GetStoreOrderingDeactivationsPath = '/stores/{storeId}/ordering-deactivations/current';

  /**
   * Retrieve the current ordering deactivation with a list of reasons.
   *
   * Retrieve the current ordering deactivation with a list of reasons.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStoreOrderingDeactivations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreOrderingDeactivations$Response(params: GetStoreOrderingDeactivations$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreOrderingDeactivationsResponse>> {
    return getStoreOrderingDeactivations(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the current ordering deactivation with a list of reasons.
   *
   * Retrieve the current ordering deactivation with a list of reasons.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStoreOrderingDeactivations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreOrderingDeactivations(params: GetStoreOrderingDeactivations$Params, context?: HttpContext): Observable<StoreOrderingDeactivationsResponse> {
    return this.getStoreOrderingDeactivations$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreOrderingDeactivationsResponse>): StoreOrderingDeactivationsResponse => r.body)
    );
  }

  /** Path part for operation `updateStoreOrderingStatus()` */
  static readonly UpdateStoreOrderingStatusPath = '/stores/{storeId}/ordering-status/{action}';

  /**
   * Updates the ordering status from a store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStoreOrderingStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStoreOrderingStatus$Response(params: UpdateStoreOrderingStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateStoreOrderingStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates the ordering status from a store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStoreOrderingStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStoreOrderingStatus(params: UpdateStoreOrderingStatus$Params, context?: HttpContext): Observable<void> {
    return this.updateStoreOrderingStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStoreAmenities()` */
  static readonly GetStoreAmenitiesPath = '/stores/{storeId}/amenities';

  /**
   * Retrieve all store's amenities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStoreAmenities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreAmenities$Response(params: GetStoreAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAmenityCollectionResponse>> {
    return getStoreAmenities(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve all store's amenities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStoreAmenities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreAmenities(params: GetStoreAmenities$Params, context?: HttpContext): Observable<StoreAmenityCollectionResponse> {
    return this.getStoreAmenities$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreAmenityCollectionResponse>): StoreAmenityCollectionResponse => r.body)
    );
  }

  /** Path part for operation `putStoreAmenities()` */
  static readonly PutStoreAmenitiesPath = '/stores/{storeId}/amenities';

  /**
   * Update store amenities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putStoreAmenities()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putStoreAmenities$Response(params: PutStoreAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateStoreAmenitiesResponse>> {
    return putStoreAmenities(this.http, this.rootUrl, params, context);
  }

  /**
   * Update store amenities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putStoreAmenities$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putStoreAmenities(params: PutStoreAmenities$Params, context?: HttpContext): Observable<UpdateStoreAmenitiesResponse> {
    return this.putStoreAmenities$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateStoreAmenitiesResponse>): UpdateStoreAmenitiesResponse => r.body)
    );
  }

  /** Path part for operation `bulkStoresAmenities()` */
  static readonly BulkStoresAmenitiesPath = '/bulk-stores-amenities';

  /**
   * Bulk update stores' amenities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkStoresAmenities()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkStoresAmenities$Response(params: BulkStoresAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStoresAmenitiesResponse>> {
    return bulkStoresAmenities(this.http, this.rootUrl, params, context);
  }

  /**
   * Bulk update stores' amenities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkStoresAmenities$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkStoresAmenities(params: BulkStoresAmenities$Params, context?: HttpContext): Observable<BulkStoresAmenitiesResponse> {
    return this.bulkStoresAmenities$Response(params, context).pipe(
      map((r: StrictHttpResponse<BulkStoresAmenitiesResponse>): BulkStoresAmenitiesResponse => r.body)
    );
  }

  /** Path part for operation `bulkStoreAmenitiesGetAll()` */
  static readonly BulkStoreAmenitiesGetAllPath = '/summary-bulk-store-amenities';

  /**
   * Fetch Bulk update to stores amenities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkStoreAmenitiesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  bulkStoreAmenitiesGetAll$Response(params: BulkStoreAmenitiesGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStoresAmenitiesListResponse>> {
    return bulkStoreAmenitiesGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch Bulk update to stores amenities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkStoreAmenitiesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bulkStoreAmenitiesGetAll(params: BulkStoreAmenitiesGetAll$Params, context?: HttpContext): Observable<BulkStoresAmenitiesListResponse> {
    return this.bulkStoreAmenitiesGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BulkStoresAmenitiesListResponse>): BulkStoresAmenitiesListResponse => r.body)
    );
  }

  /** Path part for operation `bulkStoreAmenitiesGetDetails()` */
  static readonly BulkStoreAmenitiesGetDetailsPath = '/summary-bulk-store-amenities/{bulkRequestId}/details';

  /**
   * Details of bulking operation summary.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkStoreAmenitiesGetDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  bulkStoreAmenitiesGetDetails$Response(params: BulkStoreAmenitiesGetDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStoresAmenitiesDetailsResponse>> {
    return bulkStoreAmenitiesGetDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * Details of bulking operation summary.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkStoreAmenitiesGetDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bulkStoreAmenitiesGetDetails(params: BulkStoreAmenitiesGetDetails$Params, context?: HttpContext): Observable<BulkStoresAmenitiesDetailsResponse> {
    return this.bulkStoreAmenitiesGetDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<BulkStoresAmenitiesDetailsResponse>): BulkStoresAmenitiesDetailsResponse => r.body)
    );
  }

  /** Path part for operation `storesNearby()` */
  static readonly StoresNearbyPath = '/stores-nearby';

  /**
   * Get stores based on provided coordinates, with configured delivery zones.
   *
   * Get stores based on provided coordinates, with configured delivery zones. Pagination parameters are applied to stores list. enabledDeliveryZones and deliveryZoneType are applied to stores’ delivery zones data and can influence the list of stores to retrieve
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesNearby()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesNearby$Response(params: StoresNearby$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedStoresNearbyResponse>> {
    return storesNearby(this.http, this.rootUrl, params, context);
  }

  /**
   * Get stores based on provided coordinates, with configured delivery zones.
   *
   * Get stores based on provided coordinates, with configured delivery zones. Pagination parameters are applied to stores list. enabledDeliveryZones and deliveryZoneType are applied to stores’ delivery zones data and can influence the list of stores to retrieve
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesNearby$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesNearby(params: StoresNearby$Params, context?: HttpContext): Observable<PaginatedStoresNearbyResponse> {
    return this.storesNearby$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedStoresNearbyResponse>): PaginatedStoresNearbyResponse => r.body)
    );
  }

}
